import React, { useState } from "react";
import { Accordion, Container, Row, Col } from "react-bootstrap";
import "./question.css";

const QuestionRestorative = () => {
  const [activeKeys, setActiveKeys] = useState([]);

  const handleToggle = (eventKey) => {
    setActiveKeys((prev) =>
      prev.includes(eventKey)
        ? prev.filter((key) => key !== eventKey)
        : [...prev, eventKey]
    );
  };

  return (
    <Container className="my-5">
      <h2 className="text-center mb-4 fs-40">FAQs</h2>
      <Row className="p-4">
        <Col md={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="0"
              onClick={() => handleToggle("0")}
            >
              <Accordion.Header as="h3" className="red-header">
                What is restorative dentistry?
              </Accordion.Header>
              <Accordion.Body>
                Restorative dentistry focuses on repairing and rebuilding teeth
                that are damaged, decayed, or missing - helping you to regain a
                healthy, functional, and confident smile.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="1"
              onClick={() => handleToggle("1")}
            >
              <Accordion.Header as="h3" className="red-header">
                What treatments are considered restorative dentistry?
              </Accordion.Header>
              <Accordion.Body>
                Restorative treatments include fillings, crowns, bridges, dental
                implants, dentures, and root canal therapy - all tailored to
                restore your teeth beautifully.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="4"
              onClick={() => handleToggle("4")}
            >
              <Accordion.Header as="h3" className="red-header">
                How do I know if I need restorative dental treatment?
              </Accordion.Header>
              <Accordion.Body>
                If you have a broken, painful, missing or heavily worn tooth,
                you might benefit from restorative care. We’ll assess your teeth
                carefully and recommend the best options for you.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="7"
              onClick={() => handleToggle("7")}
            >
              <Accordion.Header as="h3" className="red-header">
                Will restorative treatment hurt?
              </Accordion.Header>
              <Accordion.Body>
                We take great pride in delivering gentle, comfortable care.
                Whether you’re having a small filling or a full restoration,
                we’ll make sure you feel relaxed and pain-free throughout your
                visit.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="8"
              onClick={() => handleToggle("8")}
            >
              <Accordion.Header as="h3" className="red-header">
                How long do dental restorations last?
              </Accordion.Header>
              <Accordion.Body>
                With good oral hygiene and regular check-ups, restorations such
                as crowns and bridges can last many years. We’ll guide you on
                how best to care for your dental work.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
        <Col md={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="3"
              onClick={() => handleToggle("3")}
            >
              <Accordion.Header as="h3" className="red-header">
                Are there natural-looking options for restorations?
              </Accordion.Header>
              <Accordion.Body>
                Yes! We use high-quality, tooth-coloured materials so your
                restorations look beautifully natural and blend seamlessly with
                your smile.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="2"
              onClick={() => handleToggle("2")}
            >
              <Accordion.Header as="h3" className="red-header">
                Can you replace old metal fillings or crowns?
              </Accordion.Header>
              <Accordion.Body>
                Absolutely. Many patients choose to replace old metal
                restorations with modern, aesthetic alternatives for a more
                natural and discreet appearance.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="9"
              onClick={() => handleToggle("9")}
            >
              <Accordion.Header as="h3" className="red-header">
                What’s the difference between a crown and a bridge?
              </Accordion.Header>
              <Accordion.Body>
                A crown is a cap that covers and protects a damaged tooth, while
                a bridge is used to replace one or more missing teeth by
                anchoring onto neighbouring teeth.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="10"
              onClick={() => handleToggle("10")}
            >
              <Accordion.Header as="h3" className="red-header">
                Can missing teeth be permanently replaced?
              </Accordion.Header>
              <Accordion.Body>
                Yes, dental implants offer a permanent and highly realistic
                solution for missing teeth. We’d be delighted to discuss whether
                they’re right for you during a consultation.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="11"
              onClick={() => handleToggle("11")}
            >
              <Accordion.Header as="h3" className="red-header">
                How do I get started with restorative dentistry?
              </Accordion.Header>
              <Accordion.Body>
                Simply book an appointment with us. We’ll take the time to
                listen to your concerns, carry out a thorough examination, and
                create a personalised treatment plan just for you.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
};

export default QuestionRestorative;
